import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { FleetService } from '../../titleregistration/services/fleet.service';
import { TitleRegistrationService } from '../../titleregistration/services/titleregistration.service';
import { CreateFleetModalComponent } from './create-fleet-modal.component';
import { CustomerFleetComponent } from './customer-fleet.component';

@NgModule({
    declarations: [
        CustomerFleetComponent,
        CreateFleetModalComponent
    ],
    providers: [
        FleetService,
        TitleRegistrationService
    ],
    imports: [
        CommonModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedPipesModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerFleetComponent
    ]
})

export class CustomerFleetModule {}
